@let referentiel = this.referentiel();

@if (referentiel) {
  <div class="flex size-full flex-col">
    <div class="p-lg border-neutral-light flex h-fit items-center justify-between border-b bg-white">
      <span class="title-medium-semibold">Interrelations</span>
      @if (estVerrouille()) {
        <app-chip label="Verrouillé" variant="warning" />
      }
    </div>
    <div
      class="m-lg border-stroke-neutral-light p-lg gap-xl bg-background-ground flex h-full flex-col overflow-y-auto rounded-lg border"
    >
      @if (phases().length < 1 && !peutModifier()) {
        <app-empty-state title="Pas d'interrelations disponibles">
          <span class="text-content-secondary text-center">
            Il semble que rien n’ait été renseigné pour les Interrelations. Contactez l’administrateur pour
            déverrouiller le Référentiel et ajouter des éléments.
          </span>
        </app-empty-state>
      } @else if (phases().length < 1) {
        <app-alerte
          title="Veuillez créer des phases en premier lieu."
          message="Vous devez d'abord créer des phases dans la page Processus avant de pouvoir ajouter des interrelations."
        />
      } @else if (areInterrelationsLinkedToPhases()) {
        <div class="flex justify-between">
          <hlm-input-group class="border-grey-3 text-grey-7 w-1/2">
            <input
              class="round-l-md"
              [(ngModel)]="nom"
              placeholder="Rechercher par nom d'interrelation"
              type="text"
              hlmInputGroupInput
            />
            <hlm-input-group-addon align="inline-end">
              <ng-icon name="lucideSearch" />
            </hlm-input-group-addon>
          </hlm-input-group>
          @if (peutModifier()) {
            <button (click)="openForm()" hlmBtn>
              <ng-icon name="lucidePlus"></ng-icon>
              Nouvelle interrelation
            </button>
          }
        </div>
        @for (phase of phasesFiltrees() | trierPar: 'indice'; track phase.id) {
          <div class="gap-xs grid">
            <app-expansion-panel [titre]="phase.nom" [item]="phase">
              <div class="ml-sm" ngProjectAs="chipLeft">
                <app-chip [label]="phase.interrelations!.length | i18nPlural: interrelationMapping" />
              </div>
              <div class="flex flex-col">
                @for (
                  interrelation of phase.interrelations | trierPar: 'nom';
                  track interrelation.id;
                  let last = $last
                ) {
                  <div
                    class="pl-md pr-xs py-xs group/item hover:bg-components-background-neutral-lighter flex h-[48px] items-center justify-between hover:rounded-b-md"
                  >
                    <span class="pl-xs component-medium-medium">
                      {{ interrelation.nom }}
                    </span>
                    @if (peutModifier()) {
                      <button
                        class="p-sm invisible group-hover/item:visible"
                        [hlmDropdownMenuTrigger]="actionsInterrelationMenu"
                        [hlmDropdownMenuTriggerData]="{ $implicit: { item: interrelation, phase: phase } }"
                        (click)="$event.stopPropagation()"
                        hlmBtn
                        variant="ghost"
                        size="icon"
                      >
                        <ng-icon name="lucideEllipsisVertical" />
                      </button>
                    }
                  </div>

                  @if (!last) {
                    <div hlmItemSeparator></div>
                  }
                }
              </div>
            </app-expansion-panel>
          </div>
        }
        @if (peutModifier()) {
          <app-button-add-new (click)="openForm()" label="Ajouter une interrelation" />
        }
      } @else if (peutModifier()) {
        <button class="w-fit" (click)="openForm()" hlmBtn>
          <ng-icon name="lucidePlus"></ng-icon>
          Nouvelle interrelation
        </button>
        <app-button-add-new (click)="openForm()" label="Ajouter une interrelation" />
      }
    </div>
  </div>
}

<ng-template #actionsInterrelationMenu let-ctx>
  <hlm-dropdown-menu>
    @for (action of interrelationAction; track $index) {
      <button (triggered)="action.action(ctx.item, ctx.phase)" hlmDropdownMenuItem>
        <ng-icon [name]="action.icon" hlmMenuIcon />
        {{ action.label }}
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>
